import type { SkeletonProps } from '@mui/material';
import { Skeleton } from '@mui/material';
import { FC } from 'react';

export const VyLoader: FC<SkeletonProps> = (props) => {
  return (
    <Skeleton
      variant="rectangular"
      width="100%"
      height="92px"
      sx={{
        borderRadius: '8px',
      }}
      {...props}
    />
  );
};
